module.exports = __webpack_public_path__ + "static/media/employee-appreciation-4.3dfe2d29.jpg";